/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/update-icon/app.update-icon.component.ts.
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppUpdateService} from '../../services/app.update.service';

/**
 * Zweck: Beschreibt class AppUpdateIconComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'update-icon',
    templateUrl: 'app.update-icon.component.html',
    styleUrls: ['app.update-icon.component.scss'],
    standalone: false
})
export class AppUpdateIconComponent implements OnInit, OnDestroy {

  updateReady = new BehaviorSubject(false);

  _destroy = new Subject();

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: AppUpdateService) {
  }

/**
 * Beschreibt Methode install und ihren Rückgabevertrag.
 */
  install() {
    this.svc.installUpdate();
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._destroy.next(true);
    this._destroy.complete();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.svc.updateAvailable.pipe(takeUntil(this._destroy)).subscribe(s => {
      this.updateReady.next(s);
    });
  }
}
